export default __webpack_public_path__ + "static/media/topdev.b85b30ea.jpg";